export const APPLY_OVERRIDE = 'APPLY_OVERRIDE';
export const CLEAR_OVERRIDE = 'CLEAR_OVERRIDE';
export const SET_USER_CONVERSATION_MENU = 'SET_USER_CONVERSATION_MENU';
